import { Injectable, Renderer2 } from '@angular/core';
import { ReplaySubject } from 'rxjs';
/* import { gtag, install } from 'ga-gtag'; */

declare const ga: any;
export interface AnalyticsEvent {
  type: 'PAGEVIEW' | 'EVENT';
  category?: string;
  action?: string;
  label: string;
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable()
export class AnalyticsService {
  eventsQueue$ = new ReplaySubject<AnalyticsEvent>();

  constructor() {}

  updateConsent(consentStatus: { ad_storage: string; analytics_storage: string }) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('consent', 'update', consentStatus);
  }

  getCookieValue(name: string): string | null {
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }
}
